var map = {
	"./en-us.json": [
		132,
		2
	],
	"./es.json": [
		134,
		1
	],
	"./pt-br.json": [
		133,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 356;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/translate/languages lazy ^\.\/.*\.json$
// module id = 356
// module chunks = 39